export const recipts = [{
  name: 'Vegan Matcha Shake.',
  prev: 'bananen_shake.jpg',
  time: '10 min.',
  ingredients: [
    '½ l Almond Milk',
    'One ripe banana,',
    'Two dates',
    'One teaspoonful of chia seeds',
    'One and a half teaspoons of Matcha powder',
    '½ tsp. lemon juice'
  ],
  preparation: [
    'Peel the banana and mix it with the almond milk, the dates, the chia seeds and the Matcha powder in a large container and blend or puree it finely.',
    'Pour the shake into a glass. Stir lemon juice into shake and serve.'
  ],
  portions: 1,
  tags: [ 'Wachmacher', 'Snacks', 'Drink', 'Vegan' ]
} ,
{
  name: 'Vegan tomato soup.',
  prev: 'vegan_tomaten_suppe.jpg',
  time: '30 min.',
  ingredients: [
    '½ Onion',
    'One garlic clove,',
    'One chilli pepper',
    'Two oranges (unsprayed)',
    '2 tablespoons of olive oil',
    '2 teaspoons of tomato paste',
    '1 small tin of peeled tomatoes (150 g)',
    '200 ml of salted water',
    undefined
  ],
  preparation: [
    'Peel and finely chop the onion and garlic. Wash the chilli pepper and cut into fine rings. Peel oranges and squeeze out about 120 ml juice. Put the peel of half an orange aside.',
    'Heat olive oil in a frying pan. Add the diced onion, garlic and chilli pepper to the pan and fry briefly. Then add tomato paste and fry briefly. Add orange juice and the zest of half an orange to the pan. Let it boil down briefly.',
    'Drain the canned tomatoes and put them in the pan with salted water. Briefly bring to the boil and cook at medium heat for 15-20 minutes',
    'Remove the orange peel from the soup. Puree the soup finely. Season to taste with salt, pepper and herbs.'
  ],
  portions: 2,
  tags: [ 'Der Klassiker', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Hot coconut lentil soup.',
  prev: 'scharfe_kokos_linsensuppe_vegan.jpg',
  time: '25 min.',
  ingredients: [
    'One piece of ginger (the size of a hazelnut)',
    '1 Onion',
    '300 ml of coconut milk',
    '150 ml of water',
    '100 grams of red lentils',
    '2 tablespoons of olive oil',
    '1 tin of chopped tomatoes (200 g)',
    '½ Lemon',
    undefined
  ],
  preparation: [
    'Peel onion and ginger and cut into fine pieces. Boil water in a kettle.',
    'Heat olive oil in a deep frying pan. Add the ginger, onion and lentils, steam briefly.',
    'Add the coconut milk, boiled water and tomato pieces to the pan. Season with chilli powder. Let it boil up briefly and simmer for about 10 minutes',
    'Season soup with salt, pepper, lemon juice.'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan ginger carrot soup.',
  prev: 'vegane_ingwer_karotten_suppe.jpg',
  time: '30 min.',
  ingredients: [
    '1 Onion',
    '300 g of carrots',
    '100 ml salted water',
    'One piece of ginger (the size of a hazelnut)',
    undefined,
    '2 tablespoons of olive oil',
    undefined
  ],
  preparation: [
    'Peel and finely chop the onion and ginger. Wash, peel and chop the carrots.',
    'Heat olive oil in a pot. Fry the onion pieces briefly until they are transparent. Then add the carrot and ginger pieces and also fry briefly. Deglaze vegetables with salted water and simmer at medium heat for about 15 - 20 minutes.',
    'Finely puree the soup and season with salt and pepper. Wash and chop the parsley and sprinkle over the soup.'
  ],
  portions: 2,
  tags: [ 'Vitaminbombe', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan spinach and coconut soup.',
  prev: 'vegane_kokos_spinat_suppe.jpg',
  time: '25 min.',
  ingredients: [
    '200 ml of coconut milk',
    '100 g of celery.',
    '250 ml of water',
    '100 g of fennel',
    '200 g of spinach leaves',
    '½ chilli pepper',
    '1 carrot',
    'One piece of ginger (the size of a hazelnut)',
    undefined
  ],
  preparation: [
    'Put water and coconut milk in a pot and boil.',
    'Wash and peel the fennel and celery and cut into fine pieces. Put the vegetables into the pot and cook them at medium heat for about 10 minutes',
    'Wash the spinach, chop it up. Wash and peel the carrot and cut into fine strips. Peel and finely chop the ginger. Wash chilli, cut into fine rings.',
    'Add all the ingredients to the soup and cook at low heat for 4 minutes. Season to taste with salt and pepper.'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Chickpea and cauliflower salad.',
  prev: 'kichererbsen_blumenkohlsalat_vegan.jpg',
  time: '20 min.',
  ingredients: [
    undefined,
    '1 tin of chickpeas (drained weight 240 g)',
    'Two spring onions',
    undefined,
    '3 tablespoons of olive oil',
    '½ Lemon',
    'A teaspoon curry',
    undefined
  ],
  preparation: [
    'Wash the cauliflower, cut it into fine florets and cut it into small pieces. Heat olive oil in a pan. Fry the cauliflower for about 10 minutes at medium heat.',
    'Drain the chickpeas, rinse with water. Then place them in a bowl and add 1 tablespoon of olive oil. Wash the onions and cut into fine rings. Wash the parsley, chop them finely. Mix the onion and parsley with the chickpeas',
    'Squeeze the lemon and add lemon juice to the bowl. Add the cauliflower. Season to taste with curry, salt and pepper. Leave to cool before serving.'
  ],
  portions: 2,
  tags: [ 'Gut vorzubereiten', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Vegan Thai curry with sweet potatoes,',
  prev: 'veganes_thai_curry_suesskartoffeln.png',
  time: '30 min.',
  ingredients: [
    'Two large sweet potatoes',
    'One broccoli.',
    '½ Bunch of scallions',
    'One red pepper',
    'Two carrots',
    'One small can of coconut milk,',
    'One lime',
    '1 tablespoon soy sauce',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the potatoes, peel them and cut them into small pieces.',
    'Wash the rest of the vegetables and cut into small pieces. Squeeze the lime.',
    'Heat the olive oil in a frying pan. Add the carrot pieces and fry briefly. Then gradually add broccoli, paprika and spring onion. Briefly stir-fry. Season with salt, pepper and curry powder',
    'Add lime juice, soy sauce and the coconut milk. Add the potato pieces. Simmer over low heat until the sweet potatoes are done. Arrange and serve.'
  ],
  portions: 2,
  tags: [ 'Sättigend', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan vegetable pan with sweet potatoes',
  prev: 'vegane_gemuesepfannesuesskartoffeln.jpg',
  time: '30 min.',
  ingredients: [
    'One large sweet potato.',
    '1 Onion',
    'Three carrots',
    '1 tablespoon of olive oil',
    'One broccoli.',
    '300 ml of salted water',
    undefined
  ],
  preparation: [
    'Wash, peel and finely dice the onion and carrots. Wash the broccoli, cut off the stalk, peel and cut into small cubes. Cut off broccoli florets. Wash, peel and dice sweet potato.',
    'Heat the olive oil in a frying pan. Put the diced onion and carrot in the pan and fry them.',
    'Add the diced potatoes, fry them briefly. Then add the salted water. Add the broccoli pieces.',
    'Close the pan with the lid and simmer for about 15 minutes at medium heat.'
  ],
  portions: 2,
  tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan tofu curry.',
  prev: 'veganes_tofu_curry.jpg',
  time: '25 min.',
  ingredients: [
    '300 grams of tofu.',
    '1 small piece of ginger (1 cm)',
    '1 bunch of scallions',
    'Two carrots',
    'One yellow pepper',
    'Three ounces of cashew nuts',
    '100 ml salted water',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Peel and chop the ginger. Wash and chop the carrots, peppers and spring onions. Chop the cashew nuts coarsely. Dice the tofu.',
    'Heat the olive oil in a frying pan. Put pieces of ginger, carrots and peppers in the pan and fry briefly.',
    'Add the tofu cubes. Season all ingredients with salt, pepper and curry powder. Fry for two more minutes.',
    'Add 100 ml of salted water to the pan. Let it boil down. Season to taste with salt, pepper and curry.'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'chilli sin Carne.',
  prev: 'chili_sin_carne.jpg',
  time: '30 min.',
  ingredients: [
    '300 grams of tofu.',
    '1 Onion',
    'One garlic clove,',
    'One red pepper',
    'One red pepperoni',
    '250 ml of tomato puree',
    'One small tin of corn grains',
    'A small tin of kidney beans',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Dice the tofu. Mix 1 tablespoon of olive oil with some chilli powder and turn the tofu cubes in it',
    'Peel and finely chop the onion and garlic cubes. Wash, remove the seeds and finely chop the bell pepper and chilli pepper.',
    'Heat olive oil in a frying pan. Briefly stir-fry the tofu cubes, add salt and pepper, remove and keep warm. Put the onion, garlic and paprika in the heated pan and fry briefly. Add the strained tomatoes and season with salt and pepper. Simmer for 5 minutes at medium heat.',
    'Rinse off the corn and kidney beans and add them. Continue cooking over medium heat. Add the tofu cubes. Season to taste with salt, pepper and chilli powder.'
  ],
  portions: 2,
  tags: [ 'Fleischlose Alternative', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan chanterelle pan.',
  prev: 'vegane_pfifferlingspfanne.jpg',
  time: '30 min.',
  ingredients: [
    '300 grams of fresh chanterelles',
    '1 Onion',
    '1 bunch of chives',
    '2 tablespoons of olive oil',
    '150 ml of soy cream',
    'One tablespoon of mustard',
    undefined
  ],
  preparation: [
    'Wash the chanterelles. Peel and finely dice the onion. Wash chives and cut into fine rings',
    'Heat olive oil in a frying pan. Add the chanterelles and fry briefly. Add the onion pieces and fry briefly. Season with salt and pepper.',
    'Add soy cream and simmer briefly.',
    'Stir mustard into the sauce, season with salt and pepper. Add chives and stir.'
  ],
  portions: 2,
  tags: [ 'Ballaststoffreich', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan quinoa vegetable pan',
  prev: 'vegane_quinoa_gemuese_pfanne.jpg',
  time: '30 min.',
  ingredients: [
    '250 g of broccoli.',
    'One red pepper',
    'One garlic clove,',
    '1 carrot',
    '2 tablespoons of olive oil',
    '75 grams of peas (from the freezer)',
    '200 ml of salted water',
    '100 grams of quinoa',
    undefined
  ],
  preparation: [
    'Wash the broccoli, cut off the stalk, peel and cut into florets. Then cut the florets into small pieces.',
    'Wash and remove the seeds of the peppers and cut them into fine cubes. Wash and peel the carrot and cut into fine slices. Peel garlic, chop finely.',
    'Rinse the quinoa in a sieve with water. Boil about 400 ml of water in a pot. Add the quinoa. Simmer for 12 minutes. Remove from heat, add salt and leave to swell for another 10 minutes.',
    'Heat the olive oil in a frying pan. Add the peppers, broccoli, carrot and garlic to the pan and fry over medium heat for 5 minutes. Add the peas. Season with curry, salt, pepper.',
    'Add salted water. Let it boil up. Add quinoa and cook for 5 minutes.'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Beans with soy cream',
  prev: 'bohnen_soja.jpg',
  time: '30 min.',
  ingredients: [
    '200 g of broad beans.',
    '1 Onion',
    '1 tablespoon of olive oil',
    '150 grams of tinned peas',
    'Two stalks of celery',
    '1 tablespoon of lemon juice',
    '100 ml of soy cream',
    undefined
  ],
  preparation: [
    'Wash the beans. (Depending on taste, the skin can be removed. To do this, place the beans briefly in boiling water and remove the skin). Drain the peas.',
    'Wash, peel and chop the celery. Peel and chop the onion.',
    'Heat the olive oil in a frying pan. Add the celery and onion, stir-fry briefly. Add the beans and peas and continue to cook for about 1 minute.',
    'Add the lemon juice, boil gently. Add soy cream. Let it boil up briefly. Let simmer for 5 minutes at medium heat.',
    'Arrange with herbs as desired and serve.'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan tofu veggie pan',
  prev: 'vegane_tofu_gemuese_pfanne.jpg',
  time: '35 min.',
  ingredients: [
    'One leek,',
    '80 grams of amaranth.',
    '200 grams of tofu.',
    'One pepper.',
    '350 grams of carrots',
    '1 tablespoon of olive oil',
    '150 ml of water',
    '½ Bunch of parsley',
    '½ Lemon',
    undefined
  ],
  preparation: [
    'Add salt to the water in a pot. Add amaranth and boil briefly. Let the amaranth swell for about 20 minutes at low heat.',
    'Peel and slice the carrots. Wash the leek and cut into rings. Wash the lemon and grate the peel. Cut the tofu into strips. Wash and chop the parsley. Wash, remove the seeds and chop the peppers',
    'Heat the olive oil in a frying pan. Fry the tofu briefly. Add the leek and stir-fry briefly. Then add carrots, also stir-fry briefly. Add amaranth with a little water and cook for 5 minutes',
    'Mix in the parsley. Season to taste with salt, pepper and lemon zest.'
  ],
  portions: 2,
  tags: [ 'Mit Amaranth', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegan curry stew.',
  prev: 'veganer_curry_eintopf.jpg',
  time: '35 min.',
  ingredients: [
    '½ Leeks',
    'One large sweet potato.',
    '2 tablespoons of olive oil',
    '100 grams of lentils',
    '1TL tomato paste',
    '200 ml of water',
    undefined
  ],
  preparation: [
    'Wash the leeks, cut them into rings.Wash the sweet potato, peel and chop the sweet potato.',
    'Heat the olive oil in a frying pan. Briefly fry the leek, sweet potato and lentils. Add tomato paste, season with curry and deglaze with water. Season with salt and pepper. Simmer for about 15 minutes, stirring occasionally.',
    'Season again with salt, pepper and curry. Arrange with herbs as desired and serve'
  ],
  portions: 2,
  tags: [ 'Sättigend', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Carrot, apricot, curry,',
  prev: 'karotten_aprikosen_curry.jpg',
  time: '30 min.',
  ingredients: [
    '200 grams of tofu.',
    'One big onion,',
    '300 g of carrots.',
    '100 grams of apricots (canned)',
    'One garlic clove,',
    '100 ml of coconut milk',
    '75 ml of water',
    '1 tablespoon of olive oil',
    'One chilli pepper',
    undefined
  ],
  preparation: [
    'Cut the tofu into strips. Cut the apricots into fine cubes and keep the juice in the can. Peel the onion, carrots and garlic and cut into fine cubes. Wash the chilli pepper, cut into fine rings.',
    'Heat the olive oil in a frying pan. Fry the tofu strips over medium heat on all sides. Season with salt and pepper, remove and keep warm.',
    'Add the garlic and onion pieces to the pan and stir-fry briefly. Then add the carrot pieces, also fry briefly. Season with curry and deglaze with water.',
    'Add apricot pieces and juice, chilli rings, coconut milk. Season with salt and pepper. Add the tofu and allow to steep for 10 minutes.'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'chilli con carne.',
  prev: 'chili_con_carne.jpg',
  time: '25 min.',
  ingredients: [
    '300 grams of ground beef',
    'One chilli pepper',
    '1 Onion',
    '½ Garlic clove',
    'A big can of tomatoes.',
    'One teaspoon chilli powder',
    '1 tin of kidney beans (250g)',
    '2 tablespoons of olive oil',
    undefined
  ],
  preparation: [
    'Peel the garlic clove and onion and cut into small cubes. Heat the olive oil in a pan. stir-fry the onion and garlic for 5 minutes.',
    'Wash and chop the chilli pepper. Put it in the pan with the chilli powder. Fry for about two minutes.',
    'Add the minced meat and stir-fry. Stir in the tomatoes and kidney beans. Season to taste with salt and pepper',
    'Simmer over medium heat for about 90 minutes.'
  ],
  portions: 2,
  tags: [ 'Gut vorzubereiten', 'Lunch' ]
} ,
{
  name: 'Beef Pepper Pan',
  prev: 'rindfleisch_paprika.png',
  time: '20 min.',
  ingredients: [
    'Two pieces of steak meat',
    '1 Onion',
    'One pepper.',
    'One pepperoni',
    '2 tablespoons of olive oil',
    undefined,
    undefined
  ],
  preparation: [
    'Wash the peppers and pepperoni, remove the seeds and cut into strips. Peel the onion and cut into rings. Cut the meat into strips.',
    'Heat the olive oil in a frying pan. Fry the meat strips and season with salt and pepper. Add the pepperoni, onion and paprika and fry briefly.',
    'Dress as desired with soy sauce and serve.'
  ],
  portions: 2,
  tags: [ 'Deftig', 'Lunch' ]
} ,
{
  name: 'Sweet potato wedges.',
  prev: 'suesskartoffelspalten.jpg',
  time: '30 min.',
  ingredients: [
    '3-4 yams',
    'Three cloves of garlic',
    undefined,
    '3 tablespoons of olive oil',
    '3 tablespoons of low-fat herb curd'
  ],
  preparation: [
    'Wash the potatoes and cut them into equal slices. Spread evenly on a baking tray lined with baking paper',
    'Preheat oven to 200 degrees. Peel the garlic cloves and chop into fine pieces. Mix with olive oil and season with salt, pepper and paprika powder',
    'Spread the garlic and spice mixture evenly on the potato wedges. Bake in the oven for 15-20 minutes.',
    'Arrange potato wedges with herb curd and serve.'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ]
} ,
{
  name: 'Redfish on chanterelles',
  prev: 'rotbarsch_auf_pfifferlingen.jpg',
  time: '30 min.',
  ingredients: [
    'Two halves of redfish (300g)',
    '½ Onion',
    '150 g chanterelles (fresh or frozen)',
    '½ Bunch of scallions',
    '200 grams of small tomatoes.',
    '2 tablespoons of olive oil',
    '1 tablespoon of lemon juice',
    undefined
  ],
  preparation: [
    'Wash the fish and remove bones if necessary',
    'Drizzle the fillets with lemon juice and season with salt',
    'Peel the onion, chop into fine pieces. Wash the spring onion and cut into fine rings. Wash the chanterelles',
    'Wash the tomatoes. Put hot water from the kettle into a bowl. Cut a small slit in the tomatoes and put them in the hot water. After a few minutes, take it out and remove the skin.',
    'Put the olive oil in a pan and heat it. Add onion pieces and fry until transparent. Then add the chanterelles and fry for about 8 minutes',
    'Add the spring onions and tomatoes to the chanterelles. Allow to steep for about 3 minutes. Then season to taste with salt and pepper',
    'In a separate pan, fry the fish fillets in olive oil for 3 minutes on both sides'
  ],
  portions: 2,
  tags: [ 'Proteinreich', 'Lunch' ]
} ,
{
  name: 'chilli con carne omelette.',
  prev: 'chili_con_carne_omelette.jpg',
  time: '30 min.',
  ingredients: [
    'Four eggs',
    '1 Onion',
    'One garlic clove,',
    '2 tablespoons of olive oil',
    'One red pepper',
    'A big can of tomatoes.',
    '250 grams of ground beef',
    'One chilli pepper',
    'One teaspoon chilli powder',
    '1 tin of kidney beans (250g)',
    undefined
  ],
  preparation: [
    'Wash and chop the peppers. Peel the onion and garlic clove and chop into fine pieces. Wash the chilli pepper and cut into fine rings.',
    'Heat the olive oil in a frying pan and fry the minced meat. Add the chilli, onion, garlic and paprika pieces and fry for 2 minutes.',
    'Add the canned tomatoes and kidney beans. Season with salt, pepper and chilli powder. Stir and simmer for a few minutes.',
    'In the meantime, heat the olive oil in a second pan. Fry 2 whisked eggs over a low heat to make an omelette. Season the raw eggs with salt and pepper to taste. Carefully turn the omelette and take it out of the pan. Prepare the second omelette in the same way.',
    'Put the chilli pepper on the omelet and close.'
  ],
  portions: 2,
  tags: [ 'Low Carb', 'Breakfast', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Stuffed couscous peppers with feta',
  prev: 'couscous_paprika_mit_feta.jpg',
  time: '30 min.',
  ingredients: [
    '2 Paprika',
    '100 grams of raw couscous.',
    '1 tablespoon of olive oil',
    '100 grams of feta cheese.',
    '50 grams of olives (pitted)',
    'Three cherry tomatoes',
    undefined
  ],
  preparation: [
    'Halve, remove the seeds and wash the peppers.',
    'Boil some salted water in a pot. Remove the pot from the heat and add the couscous while stirring. Close the lid and let it swell for 5 minutes at low heat.',
    'Dice feta cheese. Wash the olives and cut into fine pieces. Wash the tomatoes and cut into fine pieces. Mix cheese, olives and tomatoes with couscous. Season with salt, pepper and basil,',
    'Preheat oven to 200 degrees Celsius. Fill the peppers with couscous-feta mixture. Put in the oven and bake for 20 minutes'
  ],
  portions: 2,
  tags: [ 'Gut vorzubereiten', 'Lunch' ]
} ,
{
  name: 'Cured pork in apple mustard sauce.',
  prev: 'kasseler_apfel.jpg',
  time: '30 min.',
  ingredients: [
    'Two boneless chops of pork',
    'Two apples.',
    '100 ml vegetable broth',
    '2 tablespoons of lemon juice',
    '2 tablespoons of mustard',
    undefined
  ],
  preparation: [
    'Wash and peel apples and cut them into small cubes. Then sprinkle with lemon juice.',
    'Heat the pan with olive oil and fry for about 3 minutes on each side. Add the diced apples and fry at low heat for another 7 minutes. Season with salt and pepper',
    'Remove the slices of sausage from the pan and keep warm. Deglaze the apple cubes with the vegetable stock. Stir in the mustard and if necessary season again with salt and pepper. Place the smoked pork in the pan and allow to simmer for 10 minutes.',
    'Serve and enjoy.'
  ],
  portions: 2,
  tags: [ 'Deftig', 'Lunch' ]
} ,
{
  name: 'Salmon on Savoy Sauce.',
  prev: 'lachs_bohnen.jpg',
  time: '30 min.',
  ingredients: [
    '350 grams of savoy cabbage',
    '4 tablespoons of low-fat cream',
    '300 g of skinless salmon fillet',
    '2 teaspoons of olive oil',
    '1 lemon in slices',
    '50 ml low-fat milk',
    'A teaspoon of dill',
    undefined
  ],
  preparation: [
    'Wash the cabbage and cut it into strips. Boil salted water. Add the savoy cabbage strips and cook until the strips are soft.',
    'Put the cream and milk in another pot and heat it up. Let it boil down until half of it is evaporated. Add the savoy cabbage and season with curry, nutmeg, salt and pepper.',
    'Heat the olive oil in a frying pan. Fry the salmon fillets at medium heat for about 3 minutes. Season with salt and pepper.',
    'Arrange everything on a plate and cover the salmon with slices of lemon, sprinkle with dill.'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch' ]
} ,
{
  name: 'Colourful oven vegetables',
  prev: 'buntes_ofengemuese.jpg',
  time: '35 min.',
  ingredients: [
    'One zucchini',
    'One red pepper',
    'One yellow pepper',
    '300 g of mushrooms.',
    '4 tomatoes',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Preheat oven to 200 degrees Celsius.',
    'Wash and slice the vegetables.Cut the tomatoes into eight pieces.',
    'Line a baking tray with baking paper and brush with oil. Put the vegetables on the baking tray. Season with salt, pepper and herbs to taste',
    'Bake for 20 minutes.'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Curry bean stew',
  prev: 'burry_bohnen_eintopf.jpg',
  time: '35 min.',
  ingredients: [
    'One zucchini',
    '1 Onion',
    'One pepper.',
    '500 ml of water',
    '1 tin of white beans',
    '1 bunch of soup vegetables, 2 carrots, ½ leek, 1 piece of celery',
    undefined,
    undefined
  ],
  preparation: [
    'Wash the vegetables, chop them up. Heat the olive oil in a pot. Add vegetables and fry briefly. Season with salt, pepper and curry. Add water and simmer for about 20 minutes.',
    'Wash the beans with water, then put them in the pot. Let simmer for about 10 minutes',
    'Serve and arrange.If you like, you can cut up low-fat turkey sausage.'
  ],
  portions: 2,
  tags: [ 'Deftig', 'Lunch' ]
} ,
{
  name: 'Shrimp pan.',
  prev: 'garnelenpfanne.jpg',
  time: '20 min.',
  ingredients: [
    '400 g of shrimps (fresh or frozen)',
    '250 g of cherry tomatoes.',
    '250 g of mushrooms',
    '1 lemon',
    'One teaspoon of mustard',
    'Four spring onions,',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Defrost the frozen shrimp before preparation',
    'Heat the olive oil in a frying pan. Fry the prawns briefly and deglaze with lemon juice.',
    'Wash the mushrooms, tomatoes and spring onions. Halve the mushrooms and tomatoes. Cut spring onion into rings. Put the mushrooms in the pan and fry them briefly.',
    'Put the cherry tomatoes and spring onions in the pan. Fry briefly.',
    'Season with salt, pepper and mustard. Arrange and sprinkle with parsley.'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Lunch' ]
} ,
{
  name: 'Herb salmon with beans',
  prev: 'krrauter_lachs_mit_bohnen.jpg',
  time: '30 min.',
  ingredients: [
    'Two skinless salmon steaks,',
    '40 grams of olives',
    '200 g of string beans.',
    '1 tablespoon of low-fat cream cheese',
    'Two teaspoons of herb butter',
    'Four cherry tomatoes.',
    undefined
  ],
  preparation: [
    'Season the salmon steaks with salt and pepper. Wash olives and cut into fine rings. Mix the olives with the herb butter and cream cheese. Season with salt and pepper.',
    'Wash the beans and boil them over medium heat in salted water.',
    'Wash the tomatoes, cut them in half. Put them together with the salmon steaks in a grill pan and fry the fish on both sides for about 3 to 4 minutes.',
    'Arrange the salmon steaks on plates. Melt the herb butter and cream cheese on the fish. Add beans and serve.'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Lunch' ]
} ,
{
  name: 'Falafel pizza.',
  prev: 'falafelpizza.jpg',
  time: '30 min.',
  ingredients: [
    'One egg',
    '1 Onion',
    '1 packet of falafel mix',
    'Three tomatoes',
    '2 slices of ham',
    'One pepper.',
    '100 grams of mushrooms'
  ],
  preparation: [
    'Peel and finely chop the onion. Wash the tomatoes and mushrooms and cut into small pieces. Wash the peppers, remove the seeds and cut into fine strips. Cut  the ham slices into small pieces.',
    'Preheat oven to 200 degrees Celsius.',
    'Prepare the falafel mix according to the package instructions. Allow to soak briefly.',
    'Mix the prepared falafel mixture with the onion cubes and the egg. Then spread on a baking tray lined with baking paper and bake for about 5 minutes',
    'Take the falafel pizza base out of the oven and cover with ham and vegetables. Sprinkle with Parmesan cheese if necessary. Put back in the oven and bake for another 10 minutes'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch', 'Snacks' ]
} ,
{
  name: 'Turkey wraps.',
  prev: 'putengeschnetzeltes_mit_tomaten.jpg',
  time: '30 min.',
  ingredients: [
    'Four eggs',
    '2 tablespoons of ground almonds',
    '1 tablespoon of olive oil',
    '200 g of turkey jerky',
    'Four cherry tomatoes.',
    'One pepper.',
    'Two teaspoons of mustard',
    undefined
  ],
  preparation: [
    'Preheat olive oil in a frying pan.',
    'Mix the eggs and ground almonds well together. Season with salt and pepper to taste.',
    'Pour half of the liquid into the pan. Distribute by twirling in the pan. Allow to rise over medium heat. Repeat the procedure for the second wrap.',
    'Wash the tomatoes and cut them into small pieces. Wash and remove the seeds from the peppers and cut into small pieces.',
    'Heat the olive oil in another pan. Add the turkey strips and fry briefly. Season with salt and pepper.',
    'Coat both wrap floors with mustard. Cover with turkey and vegetables. Roll them up and enjoy.'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Lunch', 'Snacks' ]
} ,
{
  name: 'Curry coconut lentil stew',
  prev: 'kokos_linsen.jpg',
  time: '20 min.',
  ingredients: [
    '1 large can of lentils',
    '½ Bunch of spring onions',
    '2 tablespoons of curry powder',
    'One teaspoon cayenne pepper',
    'A teaspoon of cumin',
    '½ Tin of coconut milk',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Heat the olive oil in a frying pan.',
    'Wash the spring onions and cut into rings. Put them into the pan and stir-fry them briefly. Add coconut milk and lentils. Season to taste with spices. Simmer for 15-20 minutes.'
  ],
  portions: 1,
  tags: [ 'Exotisch', 'Lunch', 'Vegan' ]
} ,
{
  name: 'Vegetable Salmon Pan',
  prev: 'lachsfilet_auf_gemuese.jpg',
  time: '30 min.',
  ingredients: [
    'One zucchini',
    '150 grams of skinless salmon',
    '1 carrot',
    'One broccoli.',
    '1 Onion',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the vegetables and cut them into small pieces. Peel the carrot and onion and cut into fine pieces. Preheat the olive oil in a pan.',
    'Place the salmon in the pan and fry on both sides over medium heat. After 3 minutes, put the vegetables in the pan and fry them too. Occasionally deglaze with water',
    'Season with salt and pepper.'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch' ]
} ,
{
  name: 'Turkey coconut pan.',
  prev: 'puten_kokos_pfanne.jpg',
  time: '20 min.',
  ingredients: [
    '400 grams of turkey jerky',
    '1 can of mushrooms',
    'One scallion',
    'A small tin of green beans',
    '250 ml of tomato puree',
    '20 ml of coconut milk',
    '2 tablespoons of tomato pesto',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the spring onion and cut into fine rings. Drain the mushrooms and beans. Heat the olive oil in a pan.',
    'Fry the turkey and onion rings over medium heat. Add the strained tomatoes, the coconut milk and the pesto.',
    'Add the mushrooms and beans. Season with salt and pepper. Simmer for about 10 minutes at medium heat.'
  ],
  portions: 2,
  tags: [ 'Superschnell', 'Lunch' ]
} ,
{
  name: 'Turkey strips with peanut sauce.',
  prev: 'putengeschnetzeltes_mit_curry_kokosmilch.jpg',
  time: '30 min.',
  ingredients: [
    '400 turkey carcasses.',
    '200 ml of coconut milk',
    '250 ml vegetable broth',
    '4 tablespoons peanut butter (unsweetened)',
    'Two carrots',
    'One garlic clove,',
    'One chilli pepper',
    '1 spring onion',
    '200 g of broccoli.',
    '½ Lemon',
    '2 tablespoons of olive oil',
    undefined
  ],
  preparation: [
    'Wash and slice the broccoli and spring onion. Wash, peel and slice the carrot. Squeeze lemon juice. Heat the olive oil in a pan.',
    'Put the vegetables and turkey strips in the pan and stir-fry briefly. Add 150 ml water to the pan. Simmer for a few minutes until the water has evaporated.',
    'Wash the chilli pepper, cut into fine rings. Peel the garlic clove and chop into fine pieces. Heat the olive oil in a pot. Briefly fry the chilli slices and garlic pieces in the saucepan. Add the coconut milk and allow to boil briefly',
    'Take the pot off the stove. Add the peanut butter and lemon juice. Season with salt and pepper.',
    'Serve the vegetables and turkey strips with the peanut sauce.'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch' ]
} ,
{
  name: 'Beef fillet on paprika vegetables',
  prev: 'rinderfilet_auf_paprikagemuse.jpg',
  time: '30 min.',
  ingredients: [
    'Two beef fillets',
    '3 peppers (red, yellow)',
    '1 Onion',
    '150 grams of mushrooms',
    'One garlic clove,',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Heat the olive oil in a frying pan. Peel and finely chop the garlic clove. Wash the peppers, remove the seeds and cut into strips. Peel and finely chop the onion. Wash and chop the mushrooms',
    'Season the beef fillets with salt and pepper. Briefly stir-fry the garlic pieces in the pan. Add the beef fillets and fry for about 7 minutes on each side. Remove and keep warm.',
    'Put the peppers, mushrooms and onion in the heated pan and fry for 5 minutes. Season with salt and pepper.',
    'Arrange the roasted vegetables with the beef fillets.'
  ],
  portions: 2,
  tags: [ 'Für Feinschmecker', 'Lunch' ]
} ,
{
  name: 'Fried kohlrabi',
  prev: 'bratkohlrabi.jpg',
  time: '30 min.',
  ingredients: [
    '1 Onion',
    '1 kohlrabi',
    '2 slices of boiled ham',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Peel and thinly slice the kohlrabi. Peel the onion and cut into fine slices',
    'Heat the olive oil in a frying pan. Put the kohlrabi slices in the pan and fry them over medium heat until they are soft. In the meantime, cut the ham into strips.',
    'Add onion rings and ham strips to the kohlrabi slices and season with salt and pepper'
  ],
  portions: 2,
  tags: [ 'Low Carb', 'Lunch', 'Snacks' ]
} ,
{
  name: 'Spicy chickpea salad.',
  prev: 'scharfer_kichererbsensalat.jpg',
  time: '10 min.',
  ingredients: [
    '300 g of precooked chickpeas',
    '1 Onion',
    'Four cherry tomatoes.',
    '1 pepper (red/yellow)',
    'One garlic clove,',
    '1 tablespoon of tomato paste',
    '1 tablespoon of olive oil',
    '1 tablespoon soy sauce',
    '1 tablespoon of herbs (e.g. parsley)',
    undefined
  ],
  preparation: [
    'Peel and finely chop the garlic and onion. Then mix with the tomato paste, olive oil and soy sauce. Season with paprika powder.',
    'Wash and chop the peppers and tomatoes. Mix with chickpeas and pour the dressing over them. Mix in the herbs at the end. Season with salt and pepper.'
  ],
  portions: 2,
  tags: [ 'Exotisch', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Cucumber Salmon Baguette',
  prev: 'gurken_lachs.jpg',
  time: '10 min.',
  ingredients: [
    'One large cucumber',
    '250 g of salmon.',
    'Eight tablespoons of cottage cheese',
    '2 tablespoons of parsley (fresh or dried)',
    'One garlic clove,',
    '½ Lemon',
    '2 tablespoons of canned peas',
    undefined
  ],
  preparation: [
    'Peel the garlic, chop finely.',
    'Wash the cucumber, peel it, cut it in half. Carefully cut out the inside of the cucumber with a knife and chop into fine pieces.',
    'Squeeze the lemon. Mix the lemon juice with cottage cheese, garlic, peas, parsley and cucumber pieces.',
    'Spread the cucumber halves with the cream and cover with smoked salmon.'
  ],
  portions: 2,
  tags: [ 'Leicht', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Tuna Cottage Cheese Snack.',
  prev: 'thunfisch_huettenkaese.png',
  time: '5 min.',
  ingredients: [
    '250 grams of cottage cheese',
    '1 can of tuna (without oil)',
    '150 grams of curd cheese.',
    '1 spring onion',
    undefined
  ],
  preparation: [
    'Wash the spring onion and cut into fine rings. Drain the tuna.',
    'Mix the tuna, curd and spring onions in a bowl.',
    'Season to taste with salt and pepper.'
  ],
  portions: 1,
  tags: [ 'Superschnell', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Vegetable Sticks and Dip',
  prev: 'gemuesesticks.png',
  time: '10 min.',
  ingredients: [
    'One pepper.',
    '½ Cucumber',
    'Two carrots.',
    '½ Bunch of radishes',
    '½ Zucchini',
    '250 grams of low-fat curd cheese.',
    '½ Bunch of chives',
    '½ Chilli pepper (alternatively chilli powder)',
    undefined
  ],
  preparation: [
    'Wash and peel the vegetables and cut them into fine strips.',
    'Wash the chives and chilli pepper, cut into fine rings.',
    'Mix the low-fat curd cheese with chives and chillies. Season with salt and pepper. Stir in a dash of lemon juice if desired. Serve the dip in a small bowl with the vegetable sticks.'
  ],
  portions: 1,
  tags: [ 'Leicht', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Mushroom Avocado Snack.',
  prev: 'champignon_avocado_snack.jpg',
  time: '25 min.',
  ingredients: [
    'One avocado.',
    '100 grams of mushrooms',
    '½ Iceberg lettuce',
    '1 carrot',
    'One tomato',
    'A handful of cashew nuts.',
    '2 tablespoons of olive oil',
    'Four tablespoons of low-fat curd',
    undefined
  ],
  preparation: [
    'Wash and cut the lettuce and put it in a bowl. Wash the carrot and tomato and cut into small pieces. Add to bowl.',
    'Cut the avocado in half, remove the core and remove the avocado flesh with a spoon. Process one half of the avocado flesh to pulp with a fork and cut the other half into small pieces.',
    'Heat the olive oil in a frying pan. Wash and slice the mushrooms. Put them into the pan and fry them briefly. Pour the mushrooms over the rest of the salad.',
    'Mix the avocado paste with low-fat curd cheese. Finely chop the cashews and add them to the avocado quark mixture. Season to taste with salt and pepper. Pour the dressing over the salad.'
  ],
  portions: 1,
  tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Colourful salad with coconut cocktail sauce.',
  prev: 'salat_mit_kokos_coacktailsauce.jpg',
  time: '10 min.',
  ingredients: [
    '½ Iceberg lettuce',
    '2 tomatoes',
    '30 grams of ham',
    '½ Cucumber',
    'Two boiled eggs',
    '200 ml of coconut milk',
    '1 tablespoon of tomato paste',
    '½ Tsp. Mustard',
    undefined
  ],
  preparation: [
    'Wash and peel the vegetables and cut them into small pieces. Peel and chop the eggs. Cut the ham into strips. Put all ingredients in a bowl.',
    'Mix the tomato paste, coconut milk and mustard well together. Season to taste.',
    'Put dressing on salad.'
  ],
  portions: 1,
  tags: [ 'Exotisch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Tuna bean salad.',
  prev: 'thunfisch_bohnen.jpg',
  time: '10 min.',
  ingredients: [
    '½ Tin of tuna in its own juices',
    'Three cherry tomatoes.',
    '80 grams of kidney beans',
    '1 Onion',
    '50 grams of corn.',
    undefined,
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash and chop the tomatoes. Peel and finely chop the onion. Drain the beans and corn. Wash and chop the parsley.',
    'Put the vegetables in a bowl. Pour olive oil over them. Season with salt and pepper.'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Protein Power Salad',
  prev: 'protein_power.jpg',
  time: '25 min.',
  ingredients: [
    'Two eggs',
    'One piece of chicken breast',
    'One scallion',
    '1 tablespoon sunflower seeds',
    'One tomato',
    '½ Cucumber',
    '1 tablespoon natural yoghurt',
    '1 tablespoon vinegar',
    '2 tablespoons of olive oil',
    undefined,
    undefined
  ],
  preparation: [
    'Wash and finely chop the tomato, spring onion and cucumber. Cut the chicken breast into strips. Heat water in a pot and boil eggs for 10 minutes. Peel and chop the eggs. Put all ingredients in a bowl.',
    'Heat olive oil in a frying pan. Fry the chicken strips briefly. Season with salt and pepper. Put the chicken strips in the bowl.',
    'Mix yoghurt, vinegar, 1 tablespoon olive oil and mustard. Season with salt and pepper and add to salad. Sprinkle salad with sunflower seeds as desired'
  ],
  portions: 1,
  tags: [ 'Mit Hähnchenfilet', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Avocado steak salad.',
  prev: 'avocado_steak.jpg',
  time: '30 min.',
  ingredients: [
    'One beef steak',
    '2 tablespoons of olive oil',
    'Four cherry tomatoes.',
    '½ Onion',
    undefined,
    '½ Cucumber',
    '½ Avocado',
    'One teaspoonful of honey',
    '1 tablespoon of lemon juice',
    undefined
  ],
  preparation: [
    'Heat olive oil in a frying pan. Season the steak with salt and pepper and fry on medium heat for 4-6 minutes on each side.',
    'Mix lemon juice with honey and 1 tablespoon of olive oil in a small bowl. Season with chilli powder and pepper.',
    'Wash the vegetables. Cut salad into bite-sized pieces. Peel and remove the seed from the avocado and cut into fine pieces. Halve the cherry tomatoes. Cut onion and cucumber into fine slices. Cut the steak into bite-sized pieces as well. Put all ingredients in a bowl and pour the dressing over.'
  ],
  portions: 1,
  tags: [ 'Für Feinschmecker', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Tofu and egg salad with quinoa.',
  prev: 'tofu_ei_salat_mit_quinoa.jpg',
  time: '15 min.',
  ingredients: [
    '100 grams of tofu',
    '50 grams of quinoa (raw)',
    'One egg',
    'Two spring onions',
    'One tomato',
    '½ Paprika',
    '1 tablespoon of olive oil',
    '2 tablespoons of lemon juice',
    'One stalk of parsley',
    undefined
  ],
  preparation: [
    'Cook the quinoa in salted water for 10 minutes. Boil the egg for about 10 minutes.',
    'Dice the tofu. Wash the tomatoes and peppers, cut into small pieces. Wash spring onion, cut into fine rings. Wash parsley, chop finely.',
    'Mix olive oil with lemon juice. Season with pepper. Chop the boiled egg.',
    'Mix the quinoa with the vegetables and egg in a bowl. Pour the dressing over it and serve.'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Fried egg with green beans and bacon',
  prev: 'spiegelei_bohnen.jpg',
  time: '15 min.',
  ingredients: [
    'One to two eggs',
    '200 g of string beans.',
    '50 g of bacon or ham',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the green beans and cut the ends off. Heat the pot with salted water and boil the beans at medium heat for 10 minutes. Cut bacon into small pieces.',
    'Heat olive oil in a frying pan. Briefly fry the bacon pieces and take them out. Then put the egg in the pan. Season with salt and pepper and add to a fried egg.',
    'Arrange green beans, bacon and fried egg on a plate. Season with salt and pepper if necessary.'
  ],
  portions: 1,
  tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Carrot zucchini buffer.',
  prev: 'karotten_zucchini_puffer.jpg',
  time: '20 min.',
  ingredients: [
    '150 grams of carrots',
    '½ Zucchini',
    '½ tablespoons of lemon juice',
    'One tablespoon parsley',
    'One egg',
    'Four tablespoons of oatmeal',
    '2 tablespoons of low-fat herb curd cheese',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash and peel the carrots and zucchini and grate them finely with a vegetable rasp.',
    'Mix the grated vegetables with lemon juice, chopped parsley, egg and oatmeal. Season with salt and pepper.',
    'Heat olive oil in a frying pan. Use a spoon to cut out small portion and place it in the heated pan. Flatten the dough a little and fry the buffers briefly on both sides over medium heat.',
    'Arrange the vegetable pancakes with herb curd on a plate.'
  ],
  portions: 1,
  tags: [ 'Low Carb', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Basil bean salad.',
  prev: 'basilikum_bohnen.jpg',
  time: '15 min.',
  ingredients: [
    '200 g of string beans.',
    'A teaspoon of pine nuts',
    undefined,
    '½ Garlic clove',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the green beans, cut off the ends and boil in salted water for 10 minutes.',
    'Wash the basil, pluck the leaves and chop them finely.Peel and crush the garlic clove.',
    'Mix garlic, basil and olive oil. Pour over the cooked beans and then sprinkle with pine nuts'
  ],
  portions: 1,
  tags: [ 'Gut vorzubereiten', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Spinach fried egg.',
  prev: 'spinat_spiegelei.jpg',
  time: '15 min.',
  ingredients: [
    'Three eggs',
    '3 tablespoons low-fat yoghurt',
    '150 g spinach (frozen or fresh)',
    '1 teaspoon of olive oil',
    undefined
  ],
  preparation: [
    'Heat olive oil in a frying pan. Add spinach to the pan. Stir-fry briefly. Push the spinach aside in the pan.',
    'Break eggs in a frying pan and have them restocked. Season with salt and pepper.',
    'Mix chilli powder with yoghurt. Then season to taste with salt, pepper and paprika powder. Serve with the eggs and spinach.'
  ],
  portions: 1,
  tags: [ 'Voller Mineralstoffe', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Berry cereal.',
  prev: 'beerenmuesli.png',
  time: '10 min.',
  ingredients: [
    '50 grams of oatmeal',
    'Three ounces of almonds',
    '150 g of berries (fresh or frozen)',
    '250 grams of low-fat curd cheese.',
    '150 ml of low-fat milk'
  ],
  preparation: [
    'Roast the almonds briefly in a pan over medium heat for about 4 minutes. Then chop finely. Wash the berries',
    'Mix oat flakes, chopped almonds, fresh (or thawed) berries, milk and low-fat curd.'
  ],
  portions: 1,
  tags: [ 'Nährstoffreich', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Mediterranean scrambled eggs',
  prev: 'mediteranes_ruehrei.png',
  time: '15 min.',
  ingredients: [
    'Three eggs',
    'Four cherry tomatoes.',
    '20 grams of arugula.',
    '100 grams of low-fat feta.',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the tomatoes and arugula. Cut the tomatoes into quarters and chop the arugula finely. Cut the feta cheese into small cubes.',
    'Put the eggs and arugula in a bowl, whisk and season with pepper.',
    'Heat the olive oil in a frying pan. Add tomatoes to the pan and fry briefly. Add eggs to the pan and allow to rise. Season with pepper.',
    'Serve the fried eggs on a plate and sprinkle with pieces of feta.'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Nut Apple Granola',
  prev: 'nuss_apfel_muesli.jpg',
  time: '5 min.',
  ingredients: [
    '1 apple',
    '30 grams of walnuts',
    '50 grams of oatmeal',
    '200 grams of low-fat curd',
    '150 ml of low-fat milk',
    undefined
  ],
  preparation: [
    'Wash the apple, cut it into small pieces.Chop the nuts.',
    'Mix the oatmeal, apple pieces, walnuts with low-fat curd and milk.Sprinkle cereal with cinnamon.'
  ],
  portions: 1,
  tags: [ 'Sättigend', 'Breakfast', 'Snacks' ]
} ,
{
  name: 'Bacon and Eggs',
  prev: 'bacon_eggs.png',
  time: '10 min.',
  ingredients: [
    'Three eggs',
    'Four low-fat strips of bacon',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Heat olive oil in a frying pan. Briefly fry the bacon strips, remove and keep warm.',
    'Add eggs to the pan and fry them. Season with salt and pepper.'
  ],
  portions: 1,
  tags: [ 'Deftig', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Mint Pickle Shake.',
  prev: 'minz_gurke.jpg',
  time: '5 min.',
  ingredients: [
    '250 grams of low-fat curd cheese.',
    'A handful of fresh mint',
    '½ Cucumber',
    '½ Lemon',
    '200 ml of water'
  ],
  preparation: [
    'Wash the cucumber and mint leaves. Cut the cucumber into small pieces. Squeeze the lemon.',
    'Place all ingredients in a tall container and blend finely with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Erfrischend', 'Dinner', 'Drink' ]
} ,
{
  name: 'Peach Pickle Shake',
  prev: 'pfirsich_gurke.jpg',
  time: '10 min.',
  ingredients: [
    'Two peaches',
    undefined,
    '50 ml of water',
    '200 g of plain yoghurt.',
    'One teaspoonful of honey'
  ],
  preparation: [
    'Wash the peaches and cucumber, cut into small pieces.',
    'Put natural yoghurt and water together with the peach and cucumber pieces in a high container. Mash with a hand blender. Sweeten with honey to taste.',
    'Serve cold.'
  ],
  portions: 1,
  tags: [ 'Einfach', 'Dinner', 'Drink' ]
} ,
{
  name: 'Lime ginger iced tea.',
  prev: 'limetten_ingwer.jpg',
  time: '15 min.',
  ingredients: [
    'Four bags of green tea',
    'Two limes',
    '35 grams of fresh ginger',
    '500 ml of water',
    'Two teaspoons of honey',
    undefined
  ],
  preparation: [
    'Wash, peel and slice the ginger. Wash the limes and cut them into fine slices.',
    'Boil water in a kettle. Place in a large container. Add the ginger and lime slices and allow to steep for about 5 minutes.',
    'Add the tea bags and let it steep for another 5 minutes. Take out the tea bag and sweeten with 2 teaspoons of honey if desired. Let the tea cool down.',
    'Serve the tea cold with ice cubes.'
  ],
  portions: 4,
  tags: [ 'Aromatisch', 'Drink' ]
} ,
{
  name: 'Lemon iced tea.',
  prev: 'zitronen_eistee.jpg',
  time: '15 min.',
  ingredients: [
    'Four bags of black tea',
    '1 Orange',
    '1 lemon',
    '500 ml of water',
    undefined
  ],
  preparation: [
    'Wash the orange and lemon and cut into fine slices.',
    'Boil water in a kettle and put it in a large container. Add the tea bags and let it steep for 5 minutes. Take out the bag.',
    'Add the lemon and orange slices to the warm tea. Allow to cool and steep.',
    'Serve with egg cubes in a glass.'
  ],
  portions: 4,
  tags: [ 'Erfrischend', 'Drink' ]
} ,
{
  name: 'Lemon blueberry iced tea',
  prev: 'zitronen_blaubeer.jpg',
  time: '15 min.',
  ingredients: [
    'Four bags of green tea',
    '200 g of blueberries.',
    '1 lemon',
    '500 ml of water',
    undefined
  ],
  preparation: [
    'Wash the  lemon and blueberries. Cut the lemon into thin slices.',
    'Boil water in a kettle and put it in a large container. Add the tea bags and let it brew for about 5 minutes. Then take the tea bag out again.',
    'Add the lemon slices and blueberries to the tea. Cool the tea in the refrigerator and let it steep',
    'Serve with egg cubes in a glass.'
  ],
  portions: 4,
  tags: [ 'Aromatisch', 'Drink' ]
} ,
{
  name: 'Pineapple Orange Smoothie.',
  prev: 'ananas_orange.jpg',
  time: '5 min.',
  ingredients: [
    '150 g of pineapple (3-4 rings of a pineapple)',
    '1 Orange',
    '100 g of spinach.',
    '250 ml of water'
  ],
  preparation: [
    'Wash the spinach and orange. Peel the orange and cut into small pieces. Cut the pineapple into small pieces.',
    'Put water, fruit and vegetables in a high container.Mash with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Exotisch', 'Drink', 'Vegan' ]
} ,
{
  name: 'Berry Power Smoothie',
  prev: 'beeren_power.jpg',
  time: '5 min.',
  ingredients: [
    '250g of berries (e.g. strawberries)',
    '½ Mango',
    '250 ml of water',
    '100 g of spinach.'
  ],
  preparation: [
    'Wash the berries, spinach and mango. Peel the mango, cut into small pieces.',
    'Put water, fruit and vegetables in a high container.Mash with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Vitaminbombe', 'Drink', 'Vegan' ]
} ,
{
  name: 'Pears and Bananas Smoothie.',
  prev: 'birnen_bananen.jpg',
  time: '5 min.',
  ingredients: [ 'Two pears', 'One banana', '100 g of spinach.', '250 ml of water' ],
  preparation: [
    'Wash the pears and spinach. Peel the banana. Cut the fruit into small pieces.',
    'Put water, fruit and vegetables in a high container.Mash with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Fruchtig', 'Drink', 'Vegan' ]
} ,
{
  name: 'Parsley Apple Smoothie',
  prev: 'petersilie_apfel.jpg',
  time: '5 min.',
  ingredients: [ 'Three apples', '150 g of parsley.', '10 g of ginger' ],
  preparation: [
    'Wash, peel and chop the ginger. Wash the apples and parsley. Chop the apples finely.',
    'Put all ingredients in a tall container.Blend with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Originelle Idee', 'Drink', 'Vegan' ]
} ,
{
  name: 'Banana Shake.',
  prev: 'bananen_shake.jpg',
  time: '10 min.',
  ingredients: [
    'One banana',
    '200 grams of low-fat curd',
    'One teaspoonful of honey',
    '400 ml of water'
  ],
  preparation: [
    'Peel and chop the banana.',
    'Put honey, low-fat curd and water in a tall container and blend with a hand blender'
  ],
  portions: 1,
  tags: [ 'Der Klassiker', 'Snacks', 'Drink' ]
} ,
{
  name: 'Honey Berry Shake',
  prev: 'honig_beeren.jpg',
  time: '5 min.',
  ingredients: [
    '250 grams of low-fat curd cheese.',
    '200 g of frozen berries (e.g. blueberries)',
    '200 ml of water',
    'One teaspoonful of honey'
  ],
  preparation: [
    'Put all ingredients in a tall vessel and mash finely.',
    'If the berries are fresh, add a little crushed ice.'
  ],
  portions: 1,
  tags: [ 'Fruchtig', 'Snacks', 'Drink' ]
} ,
{
  name: 'Apple Kiwi Shake',
  prev: 'apfel_kiwi_smoothie.jpg',
  time: '5 min.',
  ingredients: [
    '1 apple',
    'One ripe kiwi,',
    '4 tablespoons of plain yoghurt',
    '3 tablespoons of low-fat curd',
    '2-3 ice cubes',
    '250 ml of still water'
  ],
  preparation: [
    'Peel the apple and kiwi. Remove the apple seeds. Cut the fruit into small pieces.',
    'Put all ingredients in a tall container.Blend with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Superschnell', 'Snacks', 'Drink' ]
} ,
{
  name: 'Peach and banana shake.',
  prev: 'pfirsich_bananen.jpg',
  time: '10 min.',
  ingredients: [
    'One ripe peach,',
    'One ripe banana,',
    'One teaspoonful of honey',
    'Five tablespoons of low-fat curd',
    '300 ml of still cold water'
  ],
  preparation: [
    'Wash the peach. Peel the banana and peach.Cut the fruit into fine pieces.',
    'Put all ingredients in a tall container and blend with a hand blender.'
  ],
  portions: 1,
  tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ]
} ,
{
  name: 'Kiwi Lemon Shake.',
  prev: 'kiwi_zitronen_shake.jpg',
  time: '10 min.',
  ingredients: [
    'Two kiwis',
    '3 slices of pineapple',
    '½ Lemon',
    'One teaspoonful of honey',
    '150 grams of low-fat curd',
    'Two teaspoons of crushed ice,'
  ],
  preparation: [
    'Peel the kiwis, cut them into small pieces. Cut pineapple slices into small pieces. Squeeze the lemon.',
    'Mix the lemon juice with honey.',
    'Put all ingredients in a tall container and blend.'
  ],
  portions: 1,
  tags: [ 'Vitaminbombe', 'Snacks', 'Drink' ]
} ,
{
  name: 'Chocolate coconut shake.',
  prev: 'schoko_kokos.jpg',
  time: '10 min.',
  ingredients: [
    '100 ml of coconut milk',
    'One teaspoon cocoa powder (unsugared)',
    '100 ml of low-fat milk',
    'One tablespoon of crushed ice',
    'One teaspoon of shredded coconut'
  ],
  preparation: [
    'Place the cocoa powder with coconut milk, milk and ice cream in a sealable container (e.g. shaker). Shake vigorously.',
    'Sprinkle with coconut flakes at will.'
  ],
  portions: 1,
  tags: [ 'Fruchtig-süß', 'Snacks', 'Drink' ]
} ,
{
  name: 'Power Booster Shake',
  prev: 'starter_shake.png',
  time: '5 min.',
  ingredients: [
    '40 grams of oatmeal',
    '20 g of popped amaranth,',
    '100 grams of berries e.g. blueberries',
    '400 ml oat milk',
    '1 tablespoon of flax seeds',
    'Three ounces of walnut kernels',
    'One tablespoon of agave syrup',
    'Four ice cubes',
    'One teaspoon of Matcha powder'
  ],
  preparation: [
    'Chop walnut kernels.',
    'Put all ingredients in a blender and blend.'
  ],
  portions: 1,
  tags: [ 'Superschnell', 'Breakfast', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Crunchy pancakes with raspberry cream',
  prev: 'pancake.jpg',
  time: '20 min.',
  ingredients: [
    '60 grams of wholemeal flour',
    '10 g of agave syrup,',
    '140 ml of soy milk',
    '1 tablespoon of olive oil',
    'One teaspoon baking soda',
    '30 grams of popped amaranth,',
    '150 grams of raspberries (frozen)',
    'One ounce of agave syrup.',
    '100 grams of plain soy yoghurt'
  ],
  preparation: [
    'Mix the wholemeal flour, 10 g agave syrup, soy milk, baking powder and a little salt with a whisk to a dough. Then fold in the amaranth.',
    'Heat olive oil in a frying pan. Add a tablespoon of dough to the pan and form about 6 small pancakes one by one. Fry on both sides at medium heat for about 4 minutes.',
    'Put the raspberries, 30g agave syrup and the soy yoghurt in a mixer and blend finely.',
    'Serve the raspberry cream with the pancakes.'
  ],
  portions: 2,
  tags: [ 'Ballaststoffreiche Alternative', 'Breakfast', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Coco Cranberry Granola.',
  prev: 'cranberry_kokos.jpg',
  time: '10 min.',
  ingredients: [
    '100 g of oatmeal.',
    '50 g of coconut milk',
    'One ounce of agave syrup.',
    '40 grams of cranberries',
    '160 grams of soy yoghurt',
    '2 slices of pineapple',
    'Two ounces of coconut flakes'
  ],
  preparation: [
    'Mix the oat flakes with coconut milk, agave syrup, cranberries and the soy yoghurt in a bowl. Allow to steep for four minutes.',
    'Cut pineapple slices into small pieces.',
    'Mix the pineapple chunks and coconut flakes with the rest of the muesli.'
  ],
  portions: 1,
  tags: [ 'Nährstoffreich', 'Breakfast', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Sweet potato salad.',
  prev: 'suesskartoffelsalat.jpg',
  time: '30 min.',
  ingredients: [
    'One large sweet potato.',
    '100 g of mixed sprouts (e.g. radish sprouts)',
    undefined,
    '2 tablespoons of white wine vinegar',
    undefined,
    'One teaspoon horseradish',
    '3 tablespoons of olive oil',
    undefined,
    'Two spring onions',
    undefined,
    undefined
  ],
  preparation: [
    'Wash the sweet potatoes and boil them in salted water until they are soft. Drain, peel and cut into small pieces.',
    'Meanwhile, wash the rungs. Wash and squeeze the lemon. Mix the lemon juice with vinegar, mustard, horseradish, salt and pepper. Gradually add olive oil.',
    'Wash the coriander, dab dry and remove the leaves. Wash spring onions and cut into fine rings.',
    'Place the sweet potato pieces, coriander, spring onions and sprouts in a bowl. Season with salt and pepper. Pour the marinade over the salad and serve'
  ],
  portions: 2,
  tags: [ 'Sättigend', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Beetroot and horseradish soup,',
  prev: 'rote_beete_suppe.jpg',
  time: '30 min.',
  ingredients: [
    '1 Onion',
    'One sweet potato.',
    '400 g of beetroot.',
    '1 tablespoon of olive oil',
    '800 ml salted water (or vegetable stock)',
    '1 tablespoon white wine vinegar',
    undefined,
    '1 tablespoon horseradish',
    '100 ml of soy cream',
    undefined
  ],
  preparation: [
    'Peel and finely chop the onion. Wash, peel and finely chop the potato and beetroot.',
    'Heat olive oil in a frying pan. Briefly stir-fry the onion in it. Add the potatoes and beetroot and fry briefly. Deglaze with salted water. Season with salt, pepper, vinegar and cumin. Cover and simmer for 20 minutes.',
    'Addhorseradish and then purée the soup with a blender. Stir in 100 ml soy cream.'
  ],
  portions: 2,
  tags: [ 'Nährstoffreich', 'Lunch', 'Dinner', 'Vegan' ]
} ,
{
  name: 'Scrambled tofu eggs.',
  prev: 'tofu_ruehrei.png',
  time: '15 min.',
  ingredients: [
    '200 grams of soft natural tofu.',
    '1 tablespoon of olive oil',
    'One tablespoon of water',
    'Two cherry tomatoes.',
    '1 box of scallions',
    undefined,
    undefined
  ],
  preparation: [
    'Crumble the tofu with a fork. Wash the tomatoes and spring onion. Cut the tomatoes in half. Cut the spring onion into fine rings.',
    'Fry the tofu for about 3 minutes. Add the tomatoes and spring onion and fry briefly. Season with turmeric, salt and pepper.'
  ],
  portions: 1,
  tags: [ 'Vegane Alternative', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Crunchy Almond Cereal',
  prev: 'mandelmuesli.png',
  time: '10 min.',
  ingredients: [
    '20 g of popped Amaranth',
    '25 grams of unsweetened cereal',
    '40 grams of oatmeal',
    '15 grams of toasted almonds',
    '20 grams of blueberries',
    '15 grams of almonds',
    '20 g of cranberries',
    '1 tablespoon of flax seeds',
    undefined,
    '200 ml of almond milk'
  ],
  preparation: [
    'Mix together theamaranth, cornflakes, oat flakes, roasted almonds and almonds in a bowl',
    'Wash the berries. Peel the banana and cut into bite-sized pieces. Put fruit in the bowl and mix with the other ingredients',
    'Pour the almond milk over crunchy granola.'
  ],
  portions: 1,
  tags: [ 'Mit Amaranth', 'Breakfast', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Meatballs with sweet potato purée.',
  prev: 'frikadellen_mit_suesskartoffel.jpg',
  time: '30 min.',
  ingredients: [
    '400 grams of carrots',
    'One sweet potato.',
    '300 g of low-fat minced beef',
    '2 tablespoons of low-fat curd',
    'Two teaspoons of whole wheat breadcrumbs',
    '1 tablespoon of olive oil',
    'Three tablespoons of chopped herbs',
    '3-4 tbsp. low-fat milk',
    undefined
  ],
  preparation: [
    'Wash and peel the carrots and sweet potatoes and cut them into small pieces. Put them into a saucepan filled with salted water and cook for about 15 minutes.',
    'In the meantime, knead the minced meat, the low-fat curd, the wholemeal breadcrumbs, herbs, salt and pepper. Make four meatballs.',
    'Heat olive oil in a frying pan. Fry the meatballs over medium heat until they are brown.',
    'Drain the carrots and potatoes. Add low-fat milk and crush finely. Season with salt and pepper. Serve with the meatballs.'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch' ]
} ,
{
  name: 'Beetroot Tower with avocado cream',
  prev: 'rote_beete_tower.jpg',
  time: '20 min.',
  ingredients: [
    '250 g of beetroot',
    '300 grams of natural tofu,',
    '3 tablespoons of olive oil',
    'Two teaspoons of agave syrup',
    'One garlic clove,',
    'Three avocados',
    '1 tablespoon of lemon juice',
    undefined,
    undefined
  ],
  preparation: [
    'Wash the beetroot, cut it into fine slices. Heat the pot with salted water and cook for about 10 minutes until they are soft.',
    'Cut the tofu into 5 mm thick slices and then cut circles the size of beetroot with a small glass.',
    'Heat the olive oil in a pan and fry the tofu on each side for about 3 minutes. Season with salt and pepper.',
    'Peel and finely chop the garlic. Wash, cut the avocados in half and remove seeds. Purée the avocado flesh with garlic and lemon juice. Season with salt and pepper.',
    'Layer tofu slices with beetroot and avocado cream alternately. Sprinkle with cress and serve.'
  ],
  portions: 2,
  tags: [ 'Originelle Idee', 'Lunch', 'Dinner', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Kohlrabi ravioli with tomato and basil sauce',
  prev: 'kohlrabi_ravioli.jpg',
  time: '30 min.',
  ingredients: [
    '2 Kohlrabi',
    'Six tablespoons of olive oil',
    'One red pepper',
    undefined,
    '2 tomatoes',
    undefined,
    'Two cloves of garlic',
    undefined
  ],
  preparation: [
    'Wash, peel and slice or cut the kohlrabi very finely. Boil up salted water in a pot, remove from heat and let the fine kohlrabi slices simmer for about 10 minutes. Drain well with a kitchen roll. Mix 2 tablespoons of olive oil and 1 pinch of salt in a small bowl, place the kohlrabi slices in it and marinate.',
    'Wash the peppers, remove the seeds and cut into fine pieces. Peel and finely chop the onions. Heat 1 tablespoon of olive oil in a pan and fry about 1/3 of the onion and paprika pieces for about 5 minutes. Remove the pan from the heat and mash the fried tomato and onion mixture with a fork. Season with oregano, salt and pepper. Put the pan back on the stove and heat up briefly until the mixture is creamy',
    'In the middle of the marinated kohlrabi slices, add 1 tsp of the paprika-onion mixture. Place a second kohlrabi slice on top and slightly press on the side',
    'Wash and chop the tomatoes. Peel and finely chop the garlic cloves and heat the olive oil in a pan. Fry the remaining onions and garlic for about 2 minutes. Add the tomatoes and cook briefly. Add basil. Season with salt and pepper.'
  ],
  portions: 2,
  tags: [ 'Gesunde Alternative', 'Lunch', 'Dinner', 'Vegan' ]
} ,
{
  name: 'Chocolate peanut ice cream.',
  prev: 'schoko_erdnuss_eis.jpg',
  time: '25 min.',
  ingredients: [
    '200 g of peanut purée.',
    '250 g of ice cubes',
    '65 grams of agave syrup.',
    undefined,
    undefined,
    '40 grams of cocoa.'
  ],
  preparation: [
    'Mix peanut puree, agave syrup, ice cubes, salt and vanilla in a blender.',
    'Mix half the mixture with cocoa. Stir both masses with a fork again.',
    'Put ice cream in a bowl in a refrigerator for about 20 minutes.'
  ],
  portions: 1,
  tags: [ 'Erfrischend', 'Snacks', 'Vegan' ]
} ,
{
  name: 'Eggs with mustard sauce',
  prev: 'eier_senf.jpg',
  time: '25 min.',
  ingredients: [
    'Four eggs',
    'One little onion,',
    '50 ml low-fat milk',
    '2 teaspoons of dill',
    '2 tablespoons of cottage cheese',
    '2 tablespoons of low-fat yoghurt',
    'Three teaspoons of mustard',
    '1 teaspoon of olive oil',
    undefined
  ],
  preparation: [
    'Boil eggs for about 10 minutes.',
    'Peel and chop the onion.',
    'Heat olive oil in a frying pan. Fry the onion cubes briefly until they are translucent.',
    'Deglaze with milk. Stir in cottage cheese, yoghurt and mustard. Boil briefly.',
    'Peel and halve the hard-boiled eggs and serve with sauce.'
  ],
  portions: 1,
  tags: [ 'Proteinreich', 'Breakfast', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Parsley root soup.',
  prev: 'petersiliensuppe.jpg',
  time: '30 min.',
  ingredients: [
    '200 g of parsley root.',
    '½ red onion',
    'One garlic clove,',
    '200 grams of cottage cheese.',
    '½ Bunch of parsley',
    '250 ml of water',
    '1 tablespoon of olive oil',
    undefined
  ],
  preparation: [
    'Wash the parsley root, cut in half lengthwise and slice.',
    'Peel onion and garlic, dice finely.',
    'Heat olive oil in a pot. Put parsley root, onion and garlic cubes into the pot and fry for about 5 minutes.',
    'Add water and simmer for about 20 minutes.',
    'Meanwhile, wash, dry and chop the parsley. At the end of cooking, puree the soup with a hand blender. Mix in cottage cheese and sprinkle with parsley.'
  ],
  portions: 1,
  tags: [ 'Aromatisch', 'Lunch', 'Dinner', 'Snacks' ]
} ,
{
  name: 'Carrot and Pickle smoothie.',
  prev: 'moere_gurken_smothie.jpg',
  time: '5 min.',
  ingredients: [
    'One pickle',
    '300ml carrot juice (unsweetened)',
    '50 grams of oatmeal',
    '200 grams of low-fat curd',
    '100 ml of water'
  ],
  preparation: [
    'Wash cucumber, cut into large pieces.',
    'Put all the ingredients in a blender and puree until you get a creamy shake.'
  ],
  portions: 1,
  tags: [ 'Mahlzeitersatz', 'Drink' ]
}]


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/recipts/en.js